import { z } from "zod";
import { validStripeChargeAmount } from "./stripe-amounts.js";
const publicHttps = z.string().max(2048).url().refine(value => {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password;
});
export const NativeBookingConfigSchema = z.object({
    enabled: z.literal(true),
    timezone: z.string().max(100).refine(value => { try {
        new Intl.DateTimeFormat("en", { timeZone: value });
        return true;
    }
    catch {
        return false;
    } }),
    slotMinutes: z.number().int().min(5).max(240),
    leadTimeMinutes: z.number().int().min(0).max(10_080).default(60),
    horizonDays: z.number().int().min(1).max(90).default(14),
    weeklyHours: z.array(z.object({ day: z.number().int().min(0).max(6), open: z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/), close: z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/) }).refine(hours => hours.open < hours.close)).min(1).max(7)
        .refine(hours => new Set(hours.map(day => day.day)).size === hours.length),
});
export const NativePublicProductSchema = z.object({
    sku: z.string().min(1).max(120), name: z.string().min(1).max(200), description: z.string().max(1000).optional(),
    unitAmount: z.number().int().positive().max(100_000_000), currency: z.string().regex(/^[a-z]{3}$/),
    imageUrl: publicHttps.optional(), available: z.boolean(),
}).strict().refine(product => validStripeChargeAmount(product.unitAmount, product.currency), "Invalid Stripe charge units or unsupported currency");
export const NativeServicesSnapshotSchema = z.object({
    schemaVersion: z.literal(1), capturedAt: z.number().int().nonnegative(), serviceSiteId: z.string().min(1).max(256),
    booking: z.discriminatedUnion("state", [
        z.object({ state: z.literal("unavailable"), reason: z.enum(["not_configured", "invalid_configuration", "service_unavailable"]) }).strict(),
        z.object({ state: z.literal("ready"), timezone: z.string().max(100), slotMinutes: z.number().int().positive(), availabilityUrl: publicHttps, requestUrl: publicHttps }).strict(),
    ]),
    commerce: z.discriminatedUnion("state", [
        z.object({ state: z.literal("unavailable"), reason: z.enum(["not_connected", "empty_catalog", "service_unavailable"]) }).strict(),
        z.object({ state: z.literal("ready"), checkoutUrl: publicHttps, products: z.array(NativePublicProductSchema).min(1).max(200), catalogTruncated: z.boolean().default(false) }).strict(),
    ]),
}).strict();
